import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=60a148e4&scoped=true&"
import script from "./bar.vue?vue&type=script&lang=ts&"
export * from "./bar.vue?vue&type=script&lang=ts&"
import style0 from "./bar.vue?vue&type=style&index=0&id=60a148e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a148e4",
  null
  
)

export default component.exports